<template>
  {{ lineItem.frequencyCapPerNetwork }}
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';

  import LineItem from '@/common/models/lineitem/LineItem';
  import { useNetworks } from '@/org-app/services/tanstack/queries';
  import { waitForPendingQueries } from '@/org-app/services/tanstack/queryUtils';

  interface IProps {
    lineItem: LineItem;
  }

  const { lineItem } = defineProps<IProps>();

  const networksQuery = useNetworks();

  onMounted(() => {
    waitForPendingQueries([networksQuery]);
  });
</script>
